import { Injectable, inject } from '@angular/core';
import { LanguageService } from '@app/translation/services/language.service';
import type {
  LanguageOption,
  LanguageOptionsResolver,
} from '@degreed/lxp/ui/content';
import { map, type Observable } from 'rxjs';

/**
 * Concrete implementation of LANGUAGE_OPTIONS_RESOLVER for the LXP app.
 * Bridges `LanguageService.getAllLanguages()` (which yields `LanguageLocale`
 * with `{ lcid, name }`) into the catalog dropdown's `LanguageOption`
 * shape (`{ id, name }`).
 */
@Injectable({ providedIn: 'root' })
export class LanguageOptionsResolverService implements LanguageOptionsResolver {
  private readonly languages = inject(LanguageService);

  public resolve(): Observable<LanguageOption[]> {
    return this.languages.getAllLanguages().pipe(
      map((langs) =>
        langs.map((l) => ({
          id: l.lcid,
          name: l.name,
        }))
      )
    );
  }
}
